<span class="created-by">
    © {{ currentYear }} <b><a href="https://apitech.fr/" target="_blank">Apitech</a></b> - Tous droits réservés - Mentions légales
</span>
<!--
<div class="socials">
    <a href="#" target="_blank" class="ion ion-social-github"></a>
    <a href="#" target="_blank" class="ion ion-social-facebook"></a>
    <a href="#" target="_blank" class="ion ion-social-twitter"></a>
    <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
</div>
-->
<span class="app-version">
    krisalee v3.3.0
</span>
